import { cn as n } from "../../utils/utils.js";
import S from "../../../../assets/svg/ArrowDown/ArrowDown.js";
import * as O from "react";
import { jsx as s, jsxs as C } from "react/jsx-runtime";
function f(e) {
  return /* @__PURE__ */ s("option", { ...e });
}
f.displayName = "NativeSelectOption";
function y(e) {
  return /* @__PURE__ */ s("optgroup", { ...e });
}
y.displayName = "NativeSelectOptGroup";
function j(e) {
  if (!O.isValidElement(e)) return !1;
  if (typeof e.type == "string") return e.type === "option" || e.type === "optgroup";
  if (e.type === f || e.type === y || typeof e.type == "function" && e.type.name === "option") return !0;
  const t = e.props;
  return !!(t && typeof t == "object" && "value" in t);
}
var A = ({ className: e, children: t, options: b, size: l = "default", startIcon: a, value: u, defaultValue: c, onChange: m, variant: o = "default", ref: v, ...g }) => {
  const h = b?.map((r) => /* @__PURE__ */ s("option", {
    value: r.value,
    disabled: r.disabled,
    children: r.label
  }, r.value)) ?? [], N = [...t ? Array.isArray(t) ? t : [t] : [], ...h].flat(1 / 0).filter((r) => r != null && typeof r != "boolean"), d = [], i = [];
  N.forEach((r) => {
    j(r) ? d.push(r) : i.push(r);
  });
  const p = u ?? c ?? "", k = p === "" || p === null || p === void 0, x = i.length > 0 ? l === "sm" ? "h-10 pt-4 pb-1 text-sm" : "h-14 pt-6 pb-2 text-base" : l === "sm" ? "h-10 pt-4 pb-4 text-sm" : "h-14 pt-4 pb-4 text-base", w = (() => {
    switch (o) {
      case "invalid":
        return "border-error-400 bg-error-100 text-error-700";
      case "disabled":
        return "border-secondary-400 bg-secondary-100 text-secondary-600";
      case "highlight":
        return "border-secondary-700 bg-white text-secondary-900";
      default:
        return "border-secondary-700 bg-white text-secondary-900 focus:border-primary-800";
    }
  })(), _ = (() => {
    switch (o) {
      case "invalid":
        return "[&_*]:stroke-error-800 peer-focus:[&_*]:stroke-error-800";
      case "disabled":
        return "[&_*]:stroke-secondary-400";
      case "highlight":
        return "[&_*]:stroke-secondary-900";
      default:
        return "[&_*]:stroke-secondary-900 peer-focus:[&_*]:stroke-primary-800";
    }
  })();
  return /* @__PURE__ */ C("div", {
    className: "relative w-full",
    children: [
      a && /* @__PURE__ */ s("span", {
        role: "presentation",
        className: n("pointer-events-none absolute top-1/2 left-4 z-10 h-6 w-6 -translate-y-1/2", (() => {
          switch (o) {
            case "invalid":
              return "[&_*]:stroke-error-400";
            case "disabled":
              return "[&_*]:stroke-secondary-400";
            case "highlight":
              return "[&_*]:stroke-info-600";
            default:
              return "[&_*]:stroke-primary-800";
          }
        })()),
        children: a
      }),
      /* @__PURE__ */ s("select", {
        ref: v,
        value: u,
        defaultValue: c,
        onChange: m,
        "data-empty": k ? "true" : "false",
        disabled: o === "disabled",
        className: n("peer z-10 w-full appearance-none rounded-sm border-1 bg-transparent px-4 pr-10 outline-none", w, "focus-visible:ring-0 focus-visible:outline-none", x, { "pl-12": a }, e),
        ...g,
        children: d
      }),
      /* @__PURE__ */ s("span", {
        className: n(_, "pointer-events-none absolute top-1/2 right-4 h-6 w-6 -translate-y-1/2"),
        children: /* @__PURE__ */ s(S, { className: n("[&_*]:stroke-[1.5]") })
      }),
      i
    ]
  });
};
A.displayName = "NativeSelect";
export {
  A as NativeSelect,
  y as NativeSelectOptGroup,
  f as NativeSelectOption
};

//# sourceMappingURL=native-select.js.map